import Cookies from 'js-cookie'
import Login from '../components/Login.vue'
import MainLayout from '../layouts/MainLayout.vue'
import { createRouter, createWebHashHistory } from 'vue-router'

// 页面组件
import Dashboard from '../views/Dashboard.vue'
import StoreManagement from '../views/StoreManagement.vue'
import ProductList from '../views/ProductList.vue'
import AddProduct from '../views/AddProduct.vue'
import ProductCategory from '../views/ProductCategory.vue'
import OrderManagement from '../views/OrderManagement.vue'
import MemberList from '../views/MemberList.vue'
import MemberLevel from '../views/MemberLevel.vue'
import CouponManagement from '../views/CouponManagement.vue'
import ActivityManagement from '../views/ActivityManagement.vue'
import DistributorManagement from '../views/DistributorManagement.vue'
import StaffManagement from '../views/StaffManagement.vue'
import SystemSetting from '../views/SystemSetting.vue'
import Profile from '../views/Profile.vue'
import BannerManagement from '../views/BannerManagement.vue'
import HomeRecommend from '../views/HomeRecommend.vue'

// 新增页面组件
import ReservationForm from '../views/ReservationForm.vue'
import ReservationRecord from '../views/ReservationRecord.vue'
import GreenBook from '../views/GreenBook.vue'

import StorageConfig from '../views/StorageConfig.vue'
import MapConfig from '../views/MapConfig.vue'
import ChannelConfig from '../views/ChannelConfig.vue'
import PayConfig from '../views/PayConfig.vue'
import AiConfig from '../views/AiConfig.vue'
import BaseConfig from '../views/BaseConfig.vue'

// ==================== 新增：网页矩阵迁移过来的模块 ====================

// 账号管理
import AccountCategory from '../views/account/Category.vue'
import VideoAccount from '../views/account/VideoAccount.vue'

// SEO配置
import SeoconfigTitle from '../views/seoconfig/Title.vue'
import SeoconfigDesc from '../views/seoconfig/Desc.vue'
import SeoconfigTopic from '../views/seoconfig/Topic.vue'

// 视频剪辑
import MaterialVideoCp from '../views/videocut/VideoCp.vue'
import MaterialWenAn from '../views/videocut/WenAn.vue'
import VideoCutTask from '../views/videocut/VideoCut.vue'
import AllVideosWall from '../views/videocut/AllVideosWall.vue'

// 视频发布
import VideoPublishDraft from '../views/video_publish/Draft.vue'
import VideoPublishRecord from '../views/video_publish/Record.vue'

// 图文发布
import TwPublishDraft from '../views/tw_publish/Draft.vue'
import TwPublishRecord from '../views/tw_publish/Record.vue'

// 挂载管理（只保留地址挂载）
import MountingPoiGz from '../views/mounting/PoiGz.vue'

// 素材管理
import MaterialGallery from '../views/material/Gallery.vue'
import MaterialVideoSc from '../views/material/VideoSc.vue'

// 系统配置 - 创作指令
import SystemCommand from '../views/system/Command.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: MainLayout,
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: '/dashboard' },
      { path: 'dashboard', name: 'Dashboard', component: Dashboard, meta: { title: '数据看板' } },
      { path: 'home-recommend', name: 'HomeRecommend', component: HomeRecommend, meta: { title: '首页推荐' } },
      { path: 'banner', name: 'BannerManagement', component: BannerManagement, meta: { title: 'Banner管理' } },
      { path: 'pay-test', name: 'PayTest', component: () => import('../views/PayTest.vue'), meta: { title: '支付测试' } },
      { path: 'store-dashboard', name: 'StoreDashboard', component: () => import('../views/StoreDashboard.vue'), meta: { title: '数据大屏' } },
      { path: 'product-spec', name: 'ProductSpec', component: () => import('../views/ProductSpec.vue'), meta: { title: '商品规格' } },
      { path: 'store-branch', name: 'StoreBranch', component: () => import('../views/StoreBranch.vue'), meta: { title: '分店管理' } },
      { path: 'verification-record', name: 'VerificationRecord', component: () => import('../views/VerificationRecord.vue'), meta: { title: '核销记录' } },
      { path: 'member-sign', name: 'MemberSign', component: () => import('../views/MemberSign.vue'), meta: { title: '会员签到' } },
      { path: 'distributor-relation', name: 'DistributorRelation', component: () => import('../views/DistributorRelation.vue'), meta: { title: '分销关系' } },
      { path: 'invite-record', name: 'InviteRecord', component: () => import('../views/InviteRecord.vue'), meta: { title: '邀请记录' } },
      { path: 'store', name: 'StoreManagement', component: StoreManagement, meta: { title: '门店管理' } },
      { path: 'product/list', name: 'ProductList', component: ProductList, meta: { title: '商品列表' } },
      { path: 'product/add', name: 'AddProduct', component: AddProduct, meta: { title: '添加商品' } },
      { path: 'product/edit', name: 'EditProduct', component: AddProduct, meta: { title: '编辑商品' } },
      { path: 'product/category', name: 'ProductCategory', component: ProductCategory, meta: { title: '商品分类' } },
      { path: 'order', name: 'OrderManagement', component: OrderManagement, meta: { title: '订单管理' } },
      { path: 'member/list', name: 'MemberList', component: MemberList, meta: { title: '会员列表' } },
      { path: 'member/level', name: 'MemberLevel', component: MemberLevel, meta: { title: '会员等级' } },
      { path: 'member/coupon', name: 'CouponManagement', component: CouponManagement, meta: { title: '优惠券管理' } },
      { path: 'marketing/activity', name: 'ActivityManagement', component: ActivityManagement, meta: { title: '活动管理' } },
      { path: 'marketing/distributor', name: 'DistributorManagement', component: DistributorManagement, meta: { title: '分销管理' } },
      { path: 'staff', name: 'StaffManagement', component: StaffManagement, meta: { title: '员工管理' } },
      { path: 'profile', name: 'Profile', component: Profile, meta: { title: '个人中心' } },
      { path: 'setting', name: 'SystemSetting', component: SystemSetting, meta: { title: '系统设置' } },
      {
        path: 'storage-config',
        name: 'StorageConfig',
        component: StorageConfig,
        meta: { title: '存储配置' }
      },
      {
        path: 'map-config',
        name: 'MapConfig',
        component: MapConfig,
        meta: { title: '地图配置' }
      },
      {
        path: 'channel-config',
        name: 'ChannelConfig',
        component: ChannelConfig,
        meta: { title: '渠道配置' }
      },
      {
        path: 'page-paths',
        name: 'PagePaths',
        component: () => import('../views/PagePaths.vue'),
        meta: { title: '页面路径' }
      },
      {
        path: 'pay-config',
        name: 'PayConfig',
        component: PayConfig,
        meta: { title: '支付配置' }
      },
      {
        path: 'ai-config',
        name: 'AiConfig',
        component: AiConfig,
        meta: { title: '接口配置' }
      },
      {
        path: 'base-config',
        name: 'BaseConfig',
        component: BaseConfig,
        meta: { title: '基础设置' }
      },

      // 预约管理路由
      { path: 'reservation/form', name: 'ReservationForm', component: ReservationForm, meta: { title: '预约表单' } },
      { path: 'reservation/record', name: 'ReservationRecord', component: ReservationRecord, meta: { title: '预约记录' } },

      // 绿书营销路由
      { path: 'greenbook', name: 'GreenBook', component: GreenBook, meta: { title: '绿书营销' } },

      // ==================== 新增：账号管理 ====================
      {
        path: 'account',
        children: [
          {
            path: 'category',
            name: 'AccountCategory',
            component: AccountCategory,
            meta: { title: '账号分组' }
          },
          {
            path: 'account',
            name: 'VideoAccount',
            component: VideoAccount,
            meta: { title: '授权账号' }
          }
        ]
      },

      // ==================== 新增：SEO配置 ====================
      {
        path: 'seoconfig',
        children: [
          {
            path: 'title',
            name: 'SeoconfigTitle',
            component: SeoconfigTitle,
            meta: { title: '标题管理' }
          },
          {
            path: 'desc',
            name: 'SeoconfigDesc',
            component: SeoconfigDesc,
            meta: { title: '描述管理' }
          },
          {
            path: 'topic',
            name: 'SeoconfigTopic',
            component: SeoconfigTopic,
            meta: { title: '话题管理' }
          }
        ]
      },

      // ==================== 新增：视频剪辑 ====================
      {
        path: 'videocut',
        children: [
          {
            path: 'video-cut',
            name: 'VideoCutTask',
            component: VideoCutTask,
            meta: { title: '一键成片' }
          },
          {
            path: 'wen-an',
            name: 'MaterialWenAn',
            component: MaterialWenAn,
            meta: { title: '文案管理' }
          },
          {
            path: 'video-cp',
            name: 'MaterialVideoCp',
            component: MaterialVideoCp,
            meta: { title: '成片管理' }
          },
          {
            path: 'video-wall',
            name: 'AllVideosWall',
            component: AllVideosWall,
            meta: { title: '成片列表' }
          }
        ]
      },

      // ==================== 新增：视频发布 ====================
      {
        path: 'video_publish',
        children: [
          {
            path: 'draft',
            name: 'VideoPublishDraft',
            component: VideoPublishDraft,
            meta: { title: '发布任务' }
          },
          {
            path: 'record',
            name: 'VideoPublishRecord',
            component: VideoPublishRecord,
            meta: { title: '发布记录' }
          }
        ]
      },

      // ==================== 新增：图文发布 ====================
      {
        path: 'tw_publish',
        children: [
          {
            path: 'draft',
            name: 'TwPublishDraft',
            component: TwPublishDraft,
            meta: { title: '发布任务' }
          },
          {
            path: 'record',
            name: 'TwPublishRecord',
            component: TwPublishRecord,
            meta: { title: '发布记录' }
          }
        ]
      },

      // ==================== 新增：挂载管理（只有地址挂载） ====================
      {
        path: 'mounting',
        children: [
          {
            path: 'poi-gz',
            name: 'MountingPoiGz',
            component: MountingPoiGz,
            meta: { title: '地址挂载' }
          }
        ]
      },

      // ==================== 新增：素材管理 ====================
      {
        path: 'material',
        children: [
          {
            path: 'gallery',
            name: 'MaterialGallery',
            component: MaterialGallery,
            meta: { title: '图库管理' }
          },
          {
            path: 'video-sc',
            name: 'MaterialVideoSc',
            component: MaterialVideoSc,
            meta: { title: '视频管理' }
          }
        ]
      },

      // ==================== 新增：系统配置 - 创作指令（放在系统设置下） ====================
      {
        path: 'system/command',
        name: 'SystemCommand',
        component: SystemCommand,
        meta: { title: '创作指令' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory('/shop/'),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = Cookies.get('user_token')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  document.title = to.meta.title ? `${to.meta.title} - 商户后台` : '商户后台'

  if (requiresAuth) {
    if (isAuthenticated) {
      next()
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } })
    }
  } else if (to.path === '/login' && isAuthenticated) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router